// mirrorConnectionAttrs — keep the #react-root connection attributes in step with the API.
//
// WHY THIS EXISTS. Rails stamps `facebook-connected`, `facebook-pages` and `instagram-connected`
// onto #react-root once per page load, and several call sites OUTSIDE the settings modal still
// read them as their only connection signal:
//   • SocialMediaAIPage#savePostChanges — the approve-a-post guard ("You need to add a Facebook
//     page or instagram account before approving posts.")
//   • the ConnectPageModal close gate on SocialMediaAIPage
//   • SocialMediaDashboardPage#getFacebookDataFromDOM
//
// Those attributes could never drift while every settings mutation ended in a page reload. Now
// that nothing reloads, whoever changes connections has to write them back — otherwise removing
// your last Page in Settings leaves the approve guard seeing a Page that no longer exists, and a
// post gets approved with nothing to publish it to.
//
// Best effort by design: a failure to mirror must never take down the action that succeeded.
export const mirrorConnectionAttrs = (facebook, instagram) => {
  if (typeof document === 'undefined') return;
  const reactRoot = document.getElementById('react-root');
  if (!reactRoot) return;

  try {
    if (facebook) {
      const pages = Array.isArray(facebook.pages) ? facebook.pages : [];
      reactRoot.setAttribute('facebook-connected', String(Boolean(facebook.connected)));
      reactRoot.setAttribute('facebook-pages', JSON.stringify(pages));
    }
    if (instagram) {
      reactRoot.setAttribute('instagram-connected', String(Boolean(instagram.connected)));
    }
  } catch (_e) { /* the mutation itself already succeeded — never surface this */ }
};

export default mirrorConnectionAttrs;
